import { Info } from "lucide-react";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgTooltip, IgTypography } from "@intelligems/ig-theme";
import { ExpressionPayloadType } from "@intelligems/ig-types";
import { Grid, SxProps, useTheme } from "@mui/material";
import { selectedAudience } from "@src/store/slices/audiences";
import { openDrawer } from "@src/store/slices/drawers";
import { selectedExperience } from "@src/store/slices/experiences";

interface TemporaryTargetingWarningProps {
  expressions?: ExpressionPayloadType;
  expressionsIndex?: number;
  isRolloutRender?: boolean;
  sx?: SxProps;
}

export const TemporaryTargetingWarning = ({
  expressions,
  expressionsIndex,
  isRolloutRender,
  sx,
}: TemporaryTargetingWarningProps) => {
  const experience = useSelector(selectedExperience);
  const dispatch = useDispatch();
  const audience = useSelector(selectedAudience);
  const shouldRenderSwitchToTemporaryTargetingWarning = useMemo(() => {
    if (expressions && typeof expressionsIndex === "number") {
      return (
        expressions.queries[expressionsIndex].type === "visitor" &&
        expressions.queries[expressionsIndex].value === "new" &&
        expressions.queries[expressionsIndex].filter === "equals" &&
        !isRolloutRender &&
        audience.evaluationFrequency === null &&
        experience.category === "personalization"
      );
    }

    const hasVisitorNewFilter = audience.filters?.some((filter) => {
      if (filter.expression) {
        return filter.expression.some(
          (expr) =>
            expr.query &&
            expr.query.value === "new" &&
            expr.query.filter === "equals" &&
            expr.query.type === "visitor"
        );
      }
    });

    return (
      hasVisitorNewFilter &&
      audience.evaluationFrequency === null &&
      experience.category === "personalization"
    );
  }, [audience, experience, expressions, expressionsIndex, isRolloutRender]);

  if (!shouldRenderSwitchToTemporaryTargetingWarning) return null;
  return (
    <Grid item sx={sx}>
      <IgTooltip
        title={
          <IgTypography>
            When targeting new visitors you may want to consider{" "}
            <IgTypography
              onClick={() => {
                dispatch(openDrawer({ type: "audienceEvaluation" }));
              }}
              sx={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              switching to Temporary targeting
            </IgTypography>{" "}
            instead of Permanent.
          </IgTypography>
        }
        placement="bottom"
      >
        <Info
          size={18}
          // style={{ marginTop: "6px" }}
        />
      </IgTooltip>
    </Grid>
  );
};
